import { Spinner } from 'flowbite-react';

// Same shape as the page's existing "Status" pill.
const PILL_TONES = {
  neutral: 'bg-neutral-100 text-neutral-600',
  warning: 'bg-secondary-orange-50 text-secondary-orange-600',
  info: 'bg-primary-50 text-primary-700',
  success: 'bg-success-50 text-success-600',
  error: 'bg-error-50 text-error-500',
};

export const StatusPill = ({ tone, spinning, children }) => (
  <span
    data-testid="magazine-status-pill"
    className={`self-start inline-flex items-center gap-1.5 px-3 py-1 rounded-md text-sm font-semibold ${PILL_TONES[tone]}`}
  >
    {spinning && <Spinner size="xs" aria-hidden="true" />}
    {children}
  </span>
);

// One card at the top of the Active Magazine page for every state: a status
// pill, one sentence, a helper line and at most one action.
const StatusHeader = ({ tone, pill, spinning, title, children, action }) => (
  <div
    data-testid="magazine-status-header"
    className="w-full flex justify-between items-center gap-4 bg-white rounded-lg py-5 px-6 shadow-box mb-4 max-[500px]:flex-col max-[500px]:items-start"
  >
    <div className="flex flex-col gap-2">
      <StatusPill tone={tone} spinning={spinning}>
        {pill}
      </StatusPill>
      <div className="text-neutral-800 text-base font-bold">{title}</div>
      {children && (
        <div className="text-neutral-600 text-sm font-medium leading-[1.4375rem]">{children}</div>
      )}
    </div>
    {action && <div className="flex gap-2 flex-none">{action}</div>}
  </div>
);

export default StatusHeader;
